import {writable} from 'svelte/store';
import db from './db'

let section = writable()
let authenticated = writable(false)
let charts = writable([])
let chart = writable()
let chartData = writable()
const state = {
  section,
  authenticated,
  charts,
  chart,
  chartData
}

export default state